import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Prev from './Prev';
import Next from './Next';

const Challenges = ({ content, heading }) => {
  const [selected, setSelected] = useState(0);

  const handleSlideChange = (type) => {
    setSelected(
      type === 'prev'
        ? selected === 0
          ? content.length - 1
          : selected - 1
        : selected === content.length - 1
        ? 0
        : selected + 1
    );
  };

  return (
    <Container fluid style={{ background: '#e8f3ff' }}>
      <Container className="p-md-5 challenges">
        <Row>
          <Col className="d-flex flex-direction-column justify-content-center">
            <h5 className="text-lg">
              <span className="text-light-blue">{heading?.main}</span>{' '}
              <span className="text-blue">{heading?.sub}</span>
            </h5>
            {heading?.description && (
              <p className="text-grey" style={{ fontSize: '18px' }}>
                {heading.description}
              </p>
            )}
            <div>
              <span
                className="btn-transparent btn-arrow"
                onClick={() => handleSlideChange('prev')}>
                <Prev />
              </span>{' '}
              <span
                className="btn-transparent btn-arrow ml-4"
                onClick={() => handleSlideChange('next')}>
                <Next />
              </span>
            </div>
          </Col>
          <Col>
            {content?.map((item, index) => (
              <div
                className="p-5 mt-4 mt-md-2 mb-4 mb-md-0"
                key={index}
                style={{
                  background: 'linear-gradient(135deg, #0a3d91, #1e72c0)',
                  color: 'white',
                  display: selected === index ? 'block' : 'none',
                  margin: 'auto',
                  minHeight: '450px',
                }}>
                <h5 className="text-md">
                  {index + 1}. {item.title}
                </h5>

                {item.challenge && (
                  <p className="text-std text-challenge">
                    <strong>Challenge:</strong> {item.challenge}
                  </p>
                )}

                {item.perspective && (
                  <p className="text-std text-challenge">
                    <strong>Our Perspective:</strong> {item.perspective}
                  </p>
                )}

                {item.points && (
                  <div className="text-std text-challenge">
                    <p>{item.body}</p>
                    <ul className="mt-2">
                      {item.points.map((point, i) => (
                        <li
                          key={i}
                          dangerouslySetInnerHTML={{ __html: point }}></li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Challenges;
